// extracted by mini-css-extract-plugin
export default {"readOnly":"readOnlyField_readOnly__Rpo5g"};